import { GAME_ALLOWED_PROJECTS as ALLOWED_PROJECTS } from 'assets/configurations/envConfigs';


export const GAME_ALLOWED_PROJECTS = ALLOWED_PROJECTS;
export const DEFAULT_PROJECT = ALLOWED_PROJECTS[0] || {};
export const FLATTEN_RIGHTS = ALLOWED_PROJECTS.reduce((output, { drm: { router = '' } = {} } = {}) => output.concat(router), []);